import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { ADMIN, HOME } from '../../config/routes';
import { useAuth } from '../../common/auth';

const Item = styled(NavLink)`
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 0.125em;
  user-select: none;
  cursor: pointer;
  white-space: nowrap;
  padding-top: 4px;
  border-bottom: 4px solid;
  border-color: transparent;
  margin-right: 24px;
  color: #767676;
  transition: color ease 500ms, border-color ease 500ms;

  &:hover,
  &.active {
    color: #007bc7;
    border-color: #007bc7;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: 50px;
`;

function Navigation() {
  const { isAdmin } = useAuth();

  return (
    <Wrapper>
      <Item to={HOME}>Home</Item>
      {isAdmin && <Item to={ADMIN}>Admin</Item>}
    </Wrapper>
  );
}

export default Navigation;
